import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import type { SpaceAnalyticsPageProps } from '../src/components/SpaceAnalytics/SpaceAnalyticsPage.tsx';

export const SpaceAnalyticsPageLoader: LoadableType<SpaceAnalyticsPageProps> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-componentsSpaceAnalyticsPage" */ '../src/components/SpaceAnalytics/SpaceAnalyticsPage.tsx'
			)
		).SpaceAnalyticsPage,
});
